import { useContext } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import type * as  API from '@trinity/chat/api/interfaces/projects';
import { TagStateContext } from '@/screens/Project.Tags/Context';
import { indexBy } from '@trinity/chat-components';

type MutationParams = Omit<API.CreateProjectTag.Request, 'projectId'>;

export const useCreateTagMutation = (projectId: number) => {
  const { dispatch } = useContext(TagStateContext);

  const apiClient = useChatApiClient();

  return useMutation({
    mutationKey: [
      'post:projects/tags',
      projectId,
    ],
    mutationFn: (data: MutationParams) => {
      return apiClient.projects.createProjectTag({
        projectId,
        ...data,
      });
    },
    onSuccess: result => {
      dispatch({
        type: 'add-tag',
        tag: result.tag,
      });
      dispatch({
        type: 'update-ordinals',
        ordinals: indexBy(result.rebalancedOrdinals, k => k.id, v => v.ordinal),
      });
    },
  });
};